if($('footer#footer').length){
    $('.footer-icons ').append($('footer#footer .esg').clone());
    $('footer#footer .bootomFooter .date').html(new Date().getFullYear());
    $('.footer-bottom').html($('footer#footer .bootomFooter').html());
    $('footer#footer .phoneLink').append($('footer#footer .contact-box li span.tel').html());
    $(document).on('click', 'footer#footer h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('open')
    })
    $('.navigationActions').append($('footer#footer .bannerMenu'))
    $('.login-widget .popup-widget-inner').after($('footer#footer .bannerLogin'))
}
else{
    if(sessionStorage.loadedFooterObaly) {
              $('.overall-wrapper').append('<footer id="footer">'+sessionStorage.loadedFooterObaly+'</footer>')
                  $('.navigationActions').append($('footer#footer .bannerMenu'));
    $('.login-widget .popup-widget-inner').after($('footer#footer .bannerLogin'));
            } else {
              $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e),
                    t = $(a).find("footer#footer").html();
                    null !== t && ($('.overall-wrapper').append('<footer id="footer">'+t+'</footer>'))
                    sessionStorage.loadedFooterObaly = $("footer#footer").html();
                        $('.navigationActions').append($('footer#footer .bannerMenu'));
    $('.login-widget .popup-widget-inner').after($('footer#footer .bannerLogin'));
                    }
                });
            }
}